import articlePresetGallery, { transform, } from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetGallery';
import type { IGalleryShowManager } from 'Src/hooks/useShowGallery/useShowGallery.types';
export const presetGallery = (galleryShowManager: IGalleryShowManager) => articlePresetGallery((presetProps) => {
    const { data, Component: GalleryGrid } = presetProps;
    const galleryGridProps = transform(data);
    if (galleryGridProps) {
        galleryGridProps['onClickCallBack'] = ({ id }) => {
            const dispatcher = galleryShowManager(id);
            if (dispatcher) {
                dispatcher();
            }
        };
        return <GalleryGrid {...galleryGridProps}/>;
    }
    return null;
});
